import { Environments } from './env';

export const environment: Environments = {
  production: true,
  apiUrl: 'https://dev.app.autoscanplus.com.co/api',
  envName: 'development',
};
